<ng-container [formGroup]="payWithoutInvoiceForm">
  <!-- Client selection -->
  <label class="body-400">Account</label>
  <auto-complete
    formControlName="clientId"
    [options]="fullyLoadedClients$ | async"
    [triggerDisplayFn]="clientDisplayFn"
    [disableOptionFn]="clientDisableFn"
    [compareToFn]="compareClientsFn"
    [sortFn]="sortClientsFn"
    class="mt-2 d-block"
    data-cy="clients-autocomplete"
  ></auto-complete>

  <!-- Job selection -->
  <ng-container *ngIf="jobs$ | async as jobs">
    <ng-container *ngIf="authAdaptor.isAdmin && jobs?.data?.length > 0">
      <label class="body-400 mt-4">Job (optional)</label>
      <auto-complete
        formControlName="jobId"
        [options]="jobs?.data"
        [triggerDisplayFn]="jobDisplayFn"
        [compareToFn]="compareJobsFn"
        [sortFn]="sortJobsFn"
        class="mt-2 d-block"
        data-cy="jobs-autocomplete"
      ></auto-complete>
    </ng-container>
  </ng-container>

  <!-- Payment type selection -->
  <ng-container *ngIf="sortedPaymentTypes$ | async as sortedPaymentTypes">
    <label class="body-400 mt-4 mb-2">Payment type</label>
    <mat-radio-group formControlName="typeId">
      <mat-radio-button
        *ngFor="let paymentType of sortedPaymentTypes"
        [value]="paymentType.id"
        [attr.data-cy]="'payment-type-' + paymentType.type + '-radio-button'"
      >
        {{ paymentType.input.label }}
      </mat-radio-button>
    </mat-radio-group>
  </ng-container>

  <!-- Payment description input -->
  <ng-container *ngIf="selectedPaymentType$ | async as selectedPaymentType">
    <label class="body-400 mt-4">{{ selectedPaymentType.input.label }}</label>

    <ng-container [ngSwitch]="selectedPaymentType.input.type">
      <input
        *ngSwitchCase="AddOnInputType.INPUT"
        formControlName="notes"
        class="form-input mt-2"
        [ngClass]="{ 'form-input--invalid': controlHasError('notes') }"
        data-cy="payment-description-input"
      >

      <textarea
        *ngSwitchCase="AddOnInputType.TEXT_BOX"
        formControlName="notes"
        class="form-input mt-2"
        [ngClass]="{ 'form-input--invalid': controlHasError('notes') }"
        data-cy="payment-description-input"
      ></textarea>
    </ng-container>

    <mat-error *ngIf="controlHasError('notes', 'required')" class="color-red-500 small-300 mt-1">
      Payment description is required
    </mat-error>
    <mat-error *ngIf="controlHasError('notes', 'maxlength')" class="color-red-500 small-300 mt-1">
      Maximum length of 140 characters
    </mat-error>

    <p [innerHTML]="selectedPaymentType.input.hint | marked" class="markdown mt-1 small-300"></p>
  </ng-container>

  <!-- Subtotal input -->
  <label class="body-400 mt-4">Amount</label>
  <input
    maxlength="11"
    aria-labelledby="payment-amount-label"
    formControlName="subtotal"
    class="form-input form-input--amount mt-2"
    currencyMask
    [options]="{ prefix: '', align: 'right', allowNegative: 'false' }"
    [ngClass]="{ 'form-input--invalid': controlHasError('subtotal') }"
    data-cy="payment-amount"
  >
</ng-container>

